import { render, staticRenderFns } from "./BadgeSeason.vue?vue&type=template&id=afcac3a6&"
import script from "./BadgeSeason.vue?vue&type=script&lang=js&"
export * from "./BadgeSeason.vue?vue&type=script&lang=js&"
import style0 from "./BadgeSeason.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports